const erp = {};
import axios from "axios";
let frontApi = "gc-merchant-server/api/";
if (process.env.NODE_ENV !== "local") {
  axios.defaults.baseURL = window.location.origin + "/";
} 

erp.test = frontApi + "user/isLogin"; //测试接口
erp.order = frontApi + "giftcardsell/apply"; //下单
erp.applyPrice = frontApi + "giftcardsell/applyPrice"; //下单
erp.queryQuota = frontApi + "giftcardsell/queryQuota"; //下单限额
erp.queryStatus = frontApi + "giftcardsell/queryStatus"; //激活状态查询
erp.cardActivate = frontApi + "giftcardsell/cardActivate"; //激活状态查询

erp.queryPrice = frontApi + "giftcardsell/queryPrice"; //5.14.3	订单价格查询
erp.moneyIn = frontApi + "giftcardsell/moneyIn"; //充值

erp.getSMSCode = frontApi + "user/getVerCode"; //发送验证码
erp.getBankList = frontApi + "smallbusiness/querySuppBanks"; //5.10.1	查询支持发卡机构(银行)列表接口
erp.queryCard = frontApi + "giftcardsell/queryCard"; //5.14.6	激活信息查询
erp.getCardPsw = frontApi + "giftcardsell/getCardPsw"; //5.14.6	獲取密碼
erp.queryPayResult = frontApi + "giftcardsell/queryPayResult"; //5.14.6	獲取密碼

erp.queryUnpayCount = frontApi + "giftcardsell/queryUnpayCount"; //5.14.6	获取未支付订单数量
erp.cancelOtherUnpayOrder = frontApi + "giftcardsell/cancelOtherUnpayOrder"; //5.14.11	获取未支付订单数量


erp.queryUserBankCardList = frontApi + "giftcardsell/queryUserBankCardList"; //	5.14.12	查询手机绑定银行
erp.queryCardBin = frontApi + "giftcardsell/queryCardBin"; //5.14.13	查询卡所属银行
erp.signApply = frontApi + "giftcardsell/signApply"; //5.14.14	签约申请
erp.signApplyConfirm = frontApi + "giftcardsell/signApplyConfirm"; //	5.14.15	签约申请确认
erp.merOnlineAcqConfirm = frontApi + "giftcardsell/merOnlineAcqConfirm"; //5.14.16	快捷支付确认
export default erp;


 
